<script lang="ts" setup>
export interface WidgetEmailUsItemProps {
    item: WizardData
}

export interface WidgetEmailUsItemEmits {
    // eslint-disable-next-line no-unused-vars
    (e: 'select', value: WizardData): void
}

const props = defineProps<WidgetEmailUsItemProps>()
const emit = defineEmits<WidgetEmailUsItemEmits>()

const route = computed<VNuxtLinkTo | null>(() =>
    useWizardItemRouteBuilder(props.item)
)

const { data, sendEvent } = useTracker()

const handleSelect = () => {
    sendEvent({
        data: {
            ...data,
            title: props.item.title,
        },
    })

    // if children exists, show
    if (props.item.children.length > 0) {
        emit('select', props.item)
        return
    }

    // make redirect by route
    if (route.value) {
        window.open(
            useNamedRoutes(route.value),
            props.item.isExternal ? '_blank' : '_self'
        )
        return
    }
    // make redirect by url
    if (props.item.url) {
        window.open(props.item.url, props.item.isExternal ? '_blank' : '_self')
    }
}
</script>

<template>
  <button
    class="transition d-flex w-100 align-items-center rounded p-5 px-md-6 box-shadow-1 cursor-pointer email-us-item"
    @click="handleSelect"
  >
    <img
      v-if="props.item.icon?.path"
      :src="props.item.icon.path"
      width="28"
      height="28"
      alt=""
      class="widget-email-us-icon d-block flex-shrink-0 me-6"
    >
    <span
      class="fs-normal fw-bolder wizard-item-title mb-0 text-start d-flex align-items-center"
    >
      {{ props.item.title }}
      <svg
        v-if="props.item.isExternal"
        class="btn-icon d-block ms-3 flex-shrink-0"
        width="16"
        height="16"
        aria-hidden="true"
      >
        <use xlink:href="#external" />
      </svg>
    </span>
  </button>
</template>

<style scoped lang="scss">
@import './WidgetEmailUsItem.scss';
</style>
